import { post, postJson,get,deleteApi,put,putForm } from '../axios' 

const RESOURCE_BASE_PATH = '/smsRecordStatistics'

const RESOURCE_BASE_PATH1 = '/smsSentRecord'

const RESOURCE_BASE_PATH2 = '/precisionJdSuffix'

const RESOURCE_BASE_PATH3 = '/sms'

const RESOURCE_BASE_PATH4 = '/smsReceive'





/***
 * 获取短信类型
 * @param p
 */
export const shortTypes = p => get(`${RESOURCE_BASE_PATH}/types`, p);


/***
 * 获取账单汇总查询
 * @param p
 */
export const totalSearch = p => get(`${RESOURCE_BASE_PATH}/`, p);


/***
 * 短信发送明细
 * @param p
 */
export const sendDetail = p => get(`${RESOURCE_BASE_PATH}/detail`, p);


//查看短信记录
export const sendDetailRecord = p => get(`${RESOURCE_BASE_PATH1}/batch-id/page`, p);



// 短信记录
export const recordList = p => get(`${RESOURCE_BASE_PATH3}/send-batch/page`, p);

//签名管理-签名报备（官方）
export const suffixList = p => get(`${RESOURCE_BASE_PATH2}/getPrecisionJdSuffixList`, p);

//删除签名
export const delectNum = p => deleteApi(`${RESOURCE_BASE_PATH2}/`+p.id);

//签名报备-修改签名
export const updatePrecisionJdSuffixById = p => put(`${RESOURCE_BASE_PATH2}/updatePrecisionJdSuffixById`, p);

//签名报备-申请签名
export const createPrecision = p => postJson(`${RESOURCE_BASE_PATH2}/apply`, p);

//签名报备-修改号码
export const updateSuffixMobileById = p => put(`${RESOURCE_BASE_PATH2}/updateSuffixMobileById`, p);

//短信回复分页查询
export const sendRecordMes = p => get(`${RESOURCE_BASE_PATH4}/page`, p);

//短信回复分页删除
export const deleteRecordMes = id => deleteApi(`${RESOURCE_BASE_PATH4}/`, id);

//短信回复标记已读
export const readRecordMes = p => putForm(`${RESOURCE_BASE_PATH4}/read/${p}`);

//短信回复导出
export const exportRecordMes = p => get(`${RESOURCE_BASE_PATH4}/export`, p);

/** 实名报备记录表分页查询*/
export const getReportRecord = p => get(`/company-info-report-record/page`, p);

/**实名报备记录表提交or保存接口*/
export const saveReportRecord = p => postJson(`/company-info-report-record/saveRecord`, p);

/**删除接口 */
export const deleteReportRecord = (id) => get(`/company-info-report-record/deleteRecord/${id}`);










